module.exports = __webpack_public_path__ + "img/milestone__2016.b4fbdf41.png";